// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 585 ? "714ca43d" : chunkId) + "." + {"295":"4548ec9c18d8597c","389":"0b124eda1e0678e1","585":"37a19f583700f530"}[chunkId] + ".js";
};